(function () {
  'use strict';

  /* ══════════════════════════════
     1. Custom Cursor
  ══════════════════════════════ */
  if (window.matchMedia('(hover: hover)').matches) {
    const dot  = document.createElement('div'); dot.id  = 'snsei-cursor-dot';
    const ring = document.createElement('div'); ring.id = 'snsei-cursor-ring';
    document.body.append(dot, ring);

    let mx = -100, my = -100, rx = -100, ry = -100;

    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      dot.style.left  = mx + 'px';
      dot.style.top   = my + 'px';
    }, { passive: true });

    // Ring follows with lag
    (function lerp() {
      rx += (mx - rx) * 0.13;
      ry += (my - ry) * 0.13;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(lerp);
    })();

    // Grow on interactive elements
    const hovers = 'a, button, [role="button"], input, select, textarea, label, .card-wrapper';
    document.addEventListener('mouseover', e => {
      if (e.target.closest(hovers)) document.body.classList.add('snsei-cursor-hover');
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest(hovers)) document.body.classList.remove('snsei-cursor-hover');
    });
    document.addEventListener('mousedown', () => document.body.classList.add('snsei-cursor-click'));
    document.addEventListener('mouseup',   () => document.body.classList.remove('snsei-cursor-click'));
  }

  /* ══════════════════════════════
     2. Hero Text Reveal
  ══════════════════════════════ */
  function revealBannerText() {
    const heading = document.querySelector('.banner .banner__heading, .banner h2.h0, .banner h1');
    if (!heading || heading.dataset.revealed) return;
    heading.dataset.revealed = '1';

    const words = heading.textContent.trim().split(/\s+/);
    heading.innerHTML = words.map((w, i) =>
      `<span class="snsei-reveal-word"><span style="animation-delay:${0.1 + i * 0.12}s">${w}</span></span>`
    ).join(' ');
  }

  /* ══════════════════════════════
     3. Ambient Background Text
  ══════════════════════════════ */
  function addAmbientText() {
    const targets = document.querySelectorAll(
      '.sensei-brand-values, .sensei-experience, .sensei-story, .shopify-section:nth-child(4n)'
    );
    targets.forEach(el => {
      if (el.querySelector('.snsei-ambient-text')) return;
      el.classList.add('snsei-ambient-section');
      const t = document.createElement('div');
      t.className = 'snsei-ambient-text';
      t.textContent = 'SENSEI';
      el.appendChild(t);
    });
  }

  /* ══════════════════════════════
     4. Magnetic Buttons
  ══════════════════════════════ */
  function initMagnetic() {
    const btns = document.querySelectorAll('.button--primary, .button--secondary');
    btns.forEach(btn => {
      if (btn.dataset.magnetic) return;
      btn.dataset.magnetic = '1';
      btn.classList.add('snsei-magnetic');

      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const cx = r.left + r.width  / 2;
        const cy = r.top  + r.height / 2;
        const dx = (e.clientX - cx) * 0.28;
        const dy = (e.clientY - cy) * 0.28;
        btn.style.transform = `translate(${dx}px, ${dy}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  /* ══════════════════════════════
     5. Scroll-triggered number counters
     (for any element with data-count attr)
  ══════════════════════════════ */
  function initCounters() {
    const els = document.querySelectorAll('[data-snsei-count]');
    if (!els.length) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach(({ isIntersecting, target }) => {
        if (!isIntersecting) return;
        obs.unobserve(target);
        const end = parseInt(target.dataset.snseiCount, 10);
        const dur = 1400;
        const start = performance.now();
        (function tick(now) {
          const p = Math.min((now - start) / dur, 1);
          target.textContent = Math.round(p * end);
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
    }, { threshold: 0.5 });
    els.forEach(el => obs.observe(el));
  }

  /* ══════════════════════════════
     Init
  ══════════════════════════════ */
  function init() {
    revealBannerText();
    addAmbientText();
    initMagnetic();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on dynamic section loads
  document.addEventListener('shopify:section:load', () => {
    initMagnetic();
    addAmbientText();
  });
})();
